export enum EnumTipoSujeto {
  TodosLosSujetos = 0,
  Mayorista,
  ConsumidorDirectoMercado,
  Distribuidor,
  Transportista,
  GTS,
  ClienteFinal,
  Comercial = 8,
  Operador,
  RRM = 10,
  Gestor,
  ClienteExtendido = 12
}
